module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "js-pdf",
      "id": "jsPDF"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.title) + "\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69b56df0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jsPDF/component.vue
// module id = 3830
// module chunks = 1